
import _ from 'lodash';

export default {
  name: 'HappyKidsFeaturedSection',

  props: {
    data: {
      type: Object,
      default: () => ({
      }),
    },
  },

  computed: {
    shuffleProducts() {
      return _.shuffle(this.data?.Products);
    },
  },

  data() {
    return {
      isActive: true,
    }
  },
}
